<template>
  <el-dialog
    class="common-dialog"
    ref="elDialog"
    :class="[!hasTitle && 'no-title', isMobile && 'is-mobile']"
    :visible.sync="isShow"
    :title="titleText"
    :modal="modal"
    :destroy-on-close="destroyOnClose"
    :append-to-body="appendToBody"
    :show-close="isMobile ? false : showClose"
    :close-on-click-modal="isMobile ? false : closeOnClickModal"
    :width="isMobile ? '80%' : width"
    :top="top"
    :center="center"
    :fullscreen="fullscreen"
    @closed="handleClosed"
  >
    <slot name="title"></slot>
    <el-divider v-if="!isMobile && hasTitle && !hiddenHeaderLine" class="body-divider"></el-divider>
    <slot></slot>
    <template #footer v-if="!hideFooter">
      <slot name="footer">
        <div class="dialog-footer">
          <el-button v-show="!hideCancelBtn" class="footer-btn cancel-btn" @click="onCancelBtnClick">{{ cancelBtnLabel || $t(cancelBtnLabelI18nKey || 'common.btn.cancel') }}</el-button>
          <el-button class="footer-btn save-btn" :disabled="disabledSaveBtn" @click="onSaveBtnClick">{{ saveBtnLabel || $t(saveBtnLabelI18nKey || 'common.btn.confirm') }}</el-button>
        </div>
      </slot>
    </template>
    <RectLoading v-show="loading" ref="loading"></RectLoading>
  </el-dialog>
</template>

<script>
import RectLoading from '@/components/loading/rectLoading.vue'

export default {
  components: {
    RectLoading
  },
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: false
    },
    titleI18nKey: {
      type: String,
      required: false
    },
    // 是否有通过插槽自定义的标题区
    hasCustomTitle: {
      type: Boolean,
      default: false
    },
    hideFooter: {
      type: Boolean,
      default: false
    },
    hideCancelBtn: {
      type: Boolean,
      default: false
    },
    cancelBtnLabel: {
      type: String,
      required: false
    },
    cancelBtnLabelI18nKey: {
      type: String,
      required: false
    },
    saveBtnLabel: {
      type: String,
      required: false
    },
    saveBtnLabelI18nKey: {
      type: String,
      required: false
    },
    destroyOnClose: {
      type: Boolean,
      default: false
    },
    closeOnCancel: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    closeOnClickModal: {
      type: Boolean,
      default: true
    },
    disabledSaveBtn: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true
    },
    width: {
      required: false,
      default: null
    },
    top: {
      required: false,
      default: '15vh'
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    hiddenHeaderLine: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    modal: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {

    }
  },
  computed: {
    hasTitle () {
      return this.hasCustomTitle || Boolean(this.title || this.titleI18nKey)
    },
    titleText () {
      if (this.title) {
        return this.title
      } else if (this.titleI18nKey) {
        return this.$t(this.titleI18nKey)
      }
      return ''
    },
    isShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
        this.$emit('change', val)
      }
    },
    center () {
      return this.isMobile
    }
  },
  created () {

  },
  methods: {
    onCancelBtnClick () {
      if (this.loading) {
        return
      }
      if (this.closeOnCancel) {
        this.isShow = false
      }
      this.$emit('cancel')
    },
    onSaveBtnClick () {
      if (this.loading) {
        return
      }
      this.$emit('save')
    },
    handleClosed () {
      this.$emit('closed')
    }
  }
}
</script>

<style lang="scss" scoped>
.common-dialog {
  .body-divider {
    margin: 20px 0 30px;
    background: #dcdfe6;
  }

  .dialog-footer {
    .footer-btn  {
      border-radius: 2px;
      padding: 10px 30px;
    }

    .save-btn {
      background: #0096cc;
      border-color: #0096cc;
      color: #ffffff;

      &:hover {
        background: #008fc3;
        border-color: #008fc3;
      }
    }

    .is-disabled {
      background: #0096cc;
      border-color: #0096cc;

      &:hover {
        background: #0096cc;
        border-color: #0096cc;
      }
    }

    .cancel-btn {
      background: #ffffff;
      color: #606266;
    }
  }

  ::v-deep {
    .el-dialog {
      .el-dialog__header {
        padding: 34px 50px 0px;

        .el-dialog__title {
          font-size: 22px;
          font-weight: bold;
          color: #303133;
        }
      }

      .el-dialog__body {
        padding: 0px 40px 20px 50px;
      }

      .el-dialog__footer {
        padding: 15px 40px 15px 50px;
        border-top: 1px solid #ededed;
        background: #f8f8f8;
      }

      &::before {
        content: '';
        width: 10px;
        height: 100%;
        background: #666666;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }

  &.no-title {
    ::v-deep {
      .el-dialog {
        .el-dialog__header {
          padding-top: 45px;
        }
      }
    }
  }

  &.is-mobile {
    ::v-deep {
      .el-dialog {
        .el-dialog__header {
          padding: 40px 20px 0;

          .el-dialog__title {
            font-weight: 700;
            font-size: 14px;
            color: #333;
            margin-bottom: 20px;
            word-break: break-word;
          }
        }

        .el-dialog__body {
          padding: 0 20px;
          overflow: hidden auto;
          font-size: 14px;
          word-break: break-word;
          max-height: 70dvh;
          max-height: 70vh;
          color: #333;
        }

        .el-dialog__footer {
          padding: 0 20px 20px;
          background: initial;
          border: 0;
        }

        &::before {
          content: '';
          height: 20px;
          width: 100%;
          background: var(--custom-color, #0096cc);
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }

    .dialog-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .footer-btn  {
        width: 120px;
        height: 30px;
        border-radius: 15px;
        margin: 0;
        padding: 0;
        font-size: 14px;
        line-height: 30px;
        text-align: center;
        cursor: pointer;
      }

      .save-btn {
        margin-left: auto;
        background: var(--custom-color, #0096cc);
        color: #fff;
        border: 1px solid var(--custom-color, #0096cc);

        &:hover {
          background: var(--custom-color, #008fc3);
          border-color: var(--custom-color, #008fc3);
        }
      }

      .is-disabled {
        background: var(--custom-color, #0096cc);
        border-color: var(--custom-color, #0096cc);

        &:hover {
          background: var(--custom-color, #0096cc);
          border-color: var(--custom-color, #0096cc);
        }
      }

      .cancel-btn {
        background: #a9a9a9;
        color: #fff;
        border: 1px solid #a9a9a9;
      }
    }
  }

  .rect-loading {
    position: absolute;
  }
}
</style>
